import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';
import { formatAuCurrency } from 'shared/utils/currency';
import { useElementId } from 'shared/utils/elementIds';
import { Cart_ApplicationFragment, useSetRebateMonthsMutation } from '../../generated.graphql';
 

interface Props {
  application: Cart_ApplicationFragment;
}


export const RebatePeriodSelect = (props: Props) => {
  const { application } = props;
  const el = useElementId('RebatePeriod')
  const [result, setRebateMonths] = useSetRebateMonthsMutation()
  if (application.rateOptions.length > 1) {
    return (
      <>
        <div className="dropdown d-inline-block">
          <button 
            className="btn btn-link dropdown-toggle p-0" type="button" id={el} 
            style={{verticalAlign: 'baseline'}}
            disabled={result.fetching}
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
          >
            {application.rateOptions.map(o => o.rebateMonths === application.rebateMonths && (
              <MinRentalPeriod key={o.rebateMonths} minMonths={o.minMonths}/>
            ))}
             <FontAwesomeIcon icon={faAngleDown} size={'2x'} className="ml-1" style={{verticalAlign: 'middle'}} />
          </button>
          <div className="dropdown-menu" aria-labelledby={el}>
            {application.rateOptions.map(o => (
              <button 
                type="button"
                key={o.rebateMonths}
                disabled={result.fetching}
                className={cs("dropdown-item", o.rebateMonths === application.rebateMonths && 'active')}
                onClick={() => {
                  setRebateMonths({input: {portalSlug: application.portal.slug, rebateMonths: o.rebateMonths}})
                }}
              >
                <MinRentalPeriod minMonths={o.minMonths}/>{' '} 
                (${formatAuCurrency(o.rentalMonthly)} / month)
              </button>
            ))}
          </div>
        </div>

      </>
    )
  }
  return (
    <div className="d-inline-block">
      <span className="btn p-0" style={{verticalAlign: 'baseline', cursor: 'text', userSelect: 'auto'}}>
        {application.rateOptions.map(o => o.rebateMonths === application.rebateMonths && (
          <MinRentalPeriod key={o.rebateMonths} minMonths={o.minMonths}/>
        ))}
      </span>
    </div>
  )
};


export const MinRentalPeriod = ({minMonths}: {minMonths: number}) => (
  <>Minimum rental period {minMonths} month{minMonths === 1 ? '' : 's'}</>
);
